import React from 'react';
import { Tag, Icon } from 'tabler-react';
import { ENV } from '../../env';

const CopyRight = () => (
  <React.Fragment>
    Copyright © 2018-2020 Malus All rights reserved.
    <small className="dev-mode">
      <Tag>ENV: {ENV}</Tag>
    </small>
  </React.Fragment>
);

const Nav = () => (
  <React.Fragment>
    <ul>
      <li>
        <a href="http://support.getmalus.com" target="noopener noreferrer">
          常见问题
        </a>
      </li>
      <li>
        <a href="/terms" target="noopener noreferrer">
          服务协议
        </a>
      </li>
      <li>
        <a href="mailto:hi@getmalus.com">联系我们</a>
      </li>
      <li>
        <a target="noopener noreferrer" href="/r/download">
          客户端下载
        </a>
      </li>
    </ul>
    <ul className="malus-socail">
      <li>
        <a href="/r/qqgroup" target="noopener noreferrer">
          <Icon prefix="fa" name="qq" />
        </a>
      </li>
      <li>
        <a href="/r/facebook" target="noopener noreferrer">
          <Icon prefix="fa" name="facebook" />
        </a>
      </li>
      <li>
        <a href="/r/twitter" target="noopener noreferrer">
          <Icon prefix="fa" name="twitter" />
        </a>
      </li>
    </ul>
  </React.Fragment>
);

export default {
  nav: <Nav />,
  copyright: <CopyRight />,
};
